import React from 'react';

import classNames from './../utils/classNames';

const Radio = props => {
    const { name, value, children, checked, onChange, disabled } = props;
    const className = classNames('radiobutton', { 'disabled': disabled });
    return (
        <label className={className}>
            <input type="radio" name={name} value={value} checked={checked} onChange={onChange} disabled={disabled} />
            <i className="radio-icon"></i>
            <span className="radio-label">
                {children}
            </span>
        </label>
    );
};

export default Radio;


// WEBPACK FOOTER //
// ./src/components/Radio.js